class InfiniteMarquee extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('.infinite-marquee');
        this.contents = this.querySelectorAll('.marquee-content');
        this.desktopSpeed = parseInt(this.dataset.desktopSpeed, 10);
        this.mobileSpeed = parseInt(this.dataset.mobileSpeed, 10);
    }

    connectedCallback() {
        this.setSpeed();
        window.addEventListener('resize', this.setSpeed.bind(this));
    }

    setSpeed() {
        const isMobile = window.innerWidth <= 768;
        const speed = isMobile ? this.mobileSpeed : this.desktopSpeed;
        const contentWidth = this.contents[0].offsetWidth + 36;
        const duration = contentWidth / speed;

        this.contents.forEach(content => {
            content.style.animationDuration = `${duration}s`;
        });
    }
}

customElements.define('infinite-marquee', InfiniteMarquee);